import http from '@services/http';
import * as xform from '@transformers';
import { Workspace } from './interfaces';

export const getExpertFiles = ({ userId }: Workspace.Expert.GetExpertFiles.Request) => {
  return http.get(`/workspaces/expert/${userId}/files`)
    .then((data: Workspace.Expert.GetExpertFiles.Response) => ({
      items: data.items.map(xform.normalizeWorkspaceExpertFilesItem),
    }));
};